exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-wrapper[data-v-16888234]{margin-top:5px;position:relative}.avatar-wrapper .user-avatar[data-v-16888234]{width:40px;height:40px;border-radius:10px}.avatar-uploader .el-upload[data-v-16888234]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-16888234]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-16888234]{font-size:28px;color:#8c939d;width:100px;height:100px;line-height:100px;text-align:center}.avatar[data-v-16888234]{width:100px;height:100px;display:block}.rule-input[data-v-16888234]  .el-input__inner{border:0}\n", ""]);

// exports
